/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".health-check[_ngcontent-%COMP%]{background:url(health-check-bckgrnd.43769edc96047338e1f5.png) center/cover no-repeat;-webkit-animation:10s fadeIn;animation:10s fadeIn;opacity:.3;padding-top:60px;min-height:calc(100vh - 220px)}@-webkit-keyframes fadeIn{0%{opacity:0}100%{opacity:.35}}@keyframes fadeIn{0%{opacity:0}100%{opacity:.35}}"];
export { styles as styles };
